import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import { useAuth } from "../../context/userContext";
import useAlert from "../../hooks/Alert";
import defaultProfile from "../../images/defaultProfile.png";
import getImgNameFromURL from "../../Utils/getImgNameFromURL";
import Alert from "../Auth/Alert/Alert";
import IOSPicker from "../Common/IOSPicker/IOSPicker";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import CustomInputField from "../InputFeilds/CustomInputField";
import PageTitle from "../Misc/PageTitle";
import BottomSheet from "./misc/bottomSheet/BottomSheet";

const initialPickersState = {
    name: false,
    gender: false,
    birthDate: false,
    mobile: false,
    email: false,
    nationality: false,
    city: false,
    area: false,
};

const cardStyle = {
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06)",
    borderRadius: "5px",
};

const SUCCESS_ALERT_COLOR = "linear-gradient(to right, #4caf50 0%, #2e7d32 100%)";
const FAILED_ALERT_COLOR = "linear-gradient(to right, #f6743e 0%, #d42525 100%)";

// Skeleton Loader Components
const ProfileSkeleton = () => (
    <div className="position-sticky z-2">
        <div className="transition-0-5-bounce height-100">
            <PageTitle>
                <div className="transition-0-5-ease d-flex justify-content-center align-items-center mt-0">
                    <div className="transition-0-5-ease align-items-center text-white px-0 d-flex justify-content-between flex-column">
                        <div className="height-60 width-60 rounded-circle border border-3 border-wafaa-purple bg-wafaa-white-2 skeleton"></div>
                        <div className="skeleton-text mt-2" style={{ width: "150px", height: "24px" }}></div>
                    </div>
                </div>
            </PageTitle>
        </div>
    </div>
);

const CardSkeleton = ({ items = 5 }) => (
    <div className="bg-wafaa-white-2 mx-3 my-3 py-3" style={cardStyle}>
        {Array.from({ length: items }).map((_, i) => {
            const widthLeft = `${Math.floor(Math.random() * 21) + 20}%`;
            const widthRight = `${Math.floor(Math.random() * 21) + 30}%`;
            return (
                <div key={i} className="w-100 mx-auto p-2 mb-0 d-flex justify-content-between">
                    <div className="skeleton-text" style={{ width: widthLeft, height: "22px" }}></div>
                    <div className="skeleton-text" style={{ width: widthRight, height: "22px" }}></div>
                </div>
            );
        })}
    </div>
);

function MyProfile({ baseURL, clientID, appSettings }) {
    const { authUser } = useAuth();
    const { CountryResidenceCode } = appSettings;
    const { showAlert, setShowAlert, alertStyle, setAlertStyle, alertMessage, setAlertMessage, hideAlert } = useAlert();

    const homeSection = useRef();
    const fileInput = useRef();
    const mobilePrefix = appSettings?.SMS_SETTINGS?.ALLOWED_PREFIX || "";

    const [errors, setErrors] = useState({});
    const [pickers, setPickers] = useState(initialPickersState);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [isOptionsLoading, setOptionsLoading] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [fileName, setFileName] = useState("");

    const [updatePayload, setUpdatePayload] = useState({
        CUST_CODE: "",
        FIRSTNAME: "",
        LASTNAME: "",
        MOBILE: "",
        EMAIL: "",
        ADDR1: "",
        ADDR2: "",
        ADDR3: "",
        BIRTHDATE: "",
        COMPNAME: "",
        NATIONALITY: "",
        GENDER: "",
        country_code: CountryResidenceCode || "",
        city_code: "",
        area_code: "",
        CITY: "",
        AREA: "",
        COUNTRY: "",
        profile_img: "",
    });

    const [options, setOptions] = useState({
        countries: [],
        cities: [],
        areas: [],
        nationalities: [],
        genders: [{ gender_name: "Male" }, { gender_name: "Female" }],
    });

    const closePickers = useCallback(() => setPickers(initialPickersState), []);

    const handleClosePickers = (modalId) => {
        if (modalId) {
            setPickers((prev) => ({ ...prev, [modalId]: false }));
            fetchCustomerData();
        }
    };

    const handleCloseIOSPickers = (modalId) => {
        if (modalId) {
            setPickers((prev) => ({ ...prev, [modalId]: false }));
            handleUpdate();
        }
    };

    console.log(updatePayload, "updp");

    const fetchCustomerData = useCallback(async () => {
        if (!authUser) return;
        setIsDataLoading(true);
        try {
            const payLoad = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "GetLoyPoints",
                SEND_KEY: "123456",
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    TYPE_NAME: "CUSTOMER",
                    MOBILE_NUM: authUser?.MOBILE || "",
                    CUST_CODE: authUser?.CUST_CODE || "",
                    CLIENT_ID: clientID,
                },
            };

            const response = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad);

            if (!response?.data?.STATUS) {
                throw new Error(response?.data?.MESSAGE || "Failed to fetch customer data.");
            }

            const customerResponseDetail = response.data || {};
            const fullName = customerResponseDetail?.CUST_NAME?.trim().split(" ") || [];
            const firstName = fullName[0] || "";
            const lastName = fullName.slice(1).join(" ") || "";

            setUpdatePayload((prev) => ({
                ...prev,
                CUST_CODE: customerResponseDetail?.CUST_CODE,
                FIRSTNAME: firstName,
                LASTNAME: lastName,
                MOBILE: customerResponseDetail.MOBILE.replace(mobilePrefix, "") || "",
                EMAIL: customerResponseDetail?.EMAIL,
                ADDR1: customerResponseDetail?.ADDR1 || "",
                ADDR2: customerResponseDetail?.ADDR2 || "",
                ADDR3: customerResponseDetail?.ADDR3 || "",
                BIRTHDATE: customerResponseDetail?.BIRTH_DATE || "",
                COMPNAME: customerResponseDetail?.COMP_NAME,
                NATIONALITY: customerResponseDetail?.NATIONALITY?.trim(),
                GENDER: customerResponseDetail?.GENDER,
                country_code: customerResponseDetail?.country_code || CountryResidenceCode || "",
                city_code: customerResponseDetail?.city_code || "",
                area_code: customerResponseDetail?.area_code || "",
                CITY: customerResponseDetail?.CITY?.trim() || "",
                AREA: customerResponseDetail?.AREA?.trim() || "",
                COUNTRY: customerResponseDetail?.COUNTRY?.trim() || "",
                profile_img: customerResponseDetail?.PROFILE_IMAGE,
                // profile_img: getImgNameFromURL(customerResponseDetail?.PROFILE_IMAGE),
            }));
        } catch (error) {
            console.error("Error in fetchCustomerData:", error.message);
        } finally {
            setIsDataLoading(false); // End loading
        }
    }, [authUser, baseURL, clientID, mobilePrefix, CountryResidenceCode]);

    useEffect(() => {
        fetchCustomerData();
    }, [fetchCustomerData]);

    const fetchOptions = useCallback(
        async (type, payload) => {
            setOptionsLoading(true);
            try {
                const response = await axiosInstance.post(`${appSettings.AppBaseURL1}CRM_DownloadCou_Ci_Ar`, payload, { headers: { "Content-Type": "application/json" } });
                setOptions((prev) => ({ ...prev, [type]: response.data.DATA || [] }));
            } catch (error) {
                console.error(`Error loading ${type}:`, error);
                setAlertStyle({ background: FAILED_ALERT_COLOR });
                setAlertMessage({
                    success: false,
                    message: `Cannot load ${type}`,
                    mode: type?.toUpperCase(),
                });
                setShowAlert("d-block");
            } finally {
                setOptionsLoading(false);
            }
        },
        [appSettings.AppBaseURL1, setAlertMessage, setAlertStyle, setShowAlert]
    );

    useEffect(() => {
        fetchOptions("nationalities", {
            DATA: { client_id: clientID, data_type: "M_COUNTRY", flag: "ALL" },
        });
    }, [clientID, fetchOptions]);

    useEffect(() => {
        if (updatePayload.country_code) {
            fetchOptions("cities", {
                DATA: {
                    client_id: clientID,
                    data_type: "M_CITY",
                    country_code: updatePayload.country_code,
                },
            });
        }
    }, [updatePayload.country_code, clientID, fetchOptions]);

    useEffect(() => {
        if (updatePayload.city_code) {
            fetchOptions("areas", {
                DATA: {
                    client_id: clientID,
                    data_type: "M_AREA",
                    country_code: updatePayload.country_code,
                    city_code: updatePayload.city_code,
                },
            });
        }
    }, [updatePayload.city_code, clientID, fetchOptions]);

    const updateFile = async (event) => {
        event.preventDefault();
        const file = event.target.files[0];

        if (!file?.type.startsWith("image/")) {
            setAlertStyle({ background: FAILED_ALERT_COLOR });
            setAlertMessage({
                success: false,
                message: "Please select an image file",
                mode: "PROFILE IMAGE",
            });
            setShowAlert("d-block");
            return;
        }

        if (!updatePayload?.CUST_CODE || !clientID) {
            setAlertStyle({ background: FAILED_ALERT_COLOR });
            setAlertMessage({
                success: false,
                message: "Customer data is incomplete",
                mode: "PROFILE",
            });
            setShowAlert("d-block");
            return;
        }

        const formData = new FormData();
        formData.append("myFile", file);

        try {
            setFileName(file.name);
            const uploadResponse = await axiosInstance.post(`${baseURL}/ProfilePictureUploader`, formData);

            if (uploadResponse.data?.Success !== "True") {
                throw new Error("Failed to upload image");
            }

            const filePath = uploadResponse.data?.fileName;
            const fileName = filePath.split("/").pop();

            const { ADDR1, ADDR2, area_code, city_code, country_code, ...restPayload } = updatePayload;

            const updatePayloadData = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "LoyUpdateCustomer",
                SEND_KEY: "123456",
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    TYPE_NAME: "CUSTOMER_UPDATE",
                    CUSTOMER_DETAILS: {
                        ...restPayload,
                        MOBILE: mobilePrefix + updatePayload?.MOBILE,
                        profile_img: fileName,
                    },
                    CLIENT_ID: clientID,
                },
            };

            const updateResponse = await axiosInstance.post(`${baseURL}/LoyUpdateCustomer`, updatePayloadData);

            if (updateResponse.data?.STATUS) {
                setAlertStyle({ background: SUCCESS_ALERT_COLOR });
                setAlertMessage({
                    success: true,
                    message: "Profile updated successfully",
                    mode: "PROFILE",
                });
                setShowAlert("d-block");
                await fetchCustomerData();
                setFileName("");
            } else {
                throw new Error("Failed to update customer details");
            }
        } catch (error) {
            console.error("Update error:", error);
            setAlertStyle({ background: FAILED_ALERT_COLOR });
            setAlertMessage({
                success: false,
                message: error.message || "An error occurred during update",
                mode: "PROFILE",
            });
            setShowAlert("d-block");
            await fetchCustomerData();
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setUpdatePayload((prev) => ({ ...prev, [name]: value }));
    };

    const validateField = (field, validator) => {
        const newErrors = validator();
        if (Object.keys(newErrors).length > 0) {
            setTimeout(() => setErrors({}), 5000);
        }
        return Object.keys(newErrors).length === 0;
    };

    const validateNameFields = () => {
        const newErrors = {};
        if (!updatePayload.FIRSTNAME) newErrors.FIRSTNAME = "First Name is required";
        if (!updatePayload.LASTNAME) newErrors.LASTNAME = "Last Name is required";
        setErrors(newErrors);
        return newErrors;
    };

    const validateDOB = () => {
        const newErrors = {};
        const dob = new Date(updatePayload?.BIRTHDATE);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        const isBirthdayPassed = monthDiff > 0 || (monthDiff === 0 && today.getDate() >= dob.getDate());

        if (age < 18 || (age === 18 && !isBirthdayPassed)) {
            newErrors.BIRTHDATE = "You must be 18 years or older";
        }
        setErrors(newErrors);
        return newErrors;
    };

    const validateEmail = () => {
        const newErrors = {};
        if (!updatePayload.EMAIL || !/\S+@\S+\.\S+/.test(updatePayload.EMAIL)) {
            newErrors.EMAIL = "Invalid Email Address";
        }
        setErrors(newErrors);
        return newErrors;
    };

    const validateMobile = () => {
        const newErrors = {};
        if (!updatePayload.MOBILE) {
            newErrors.MOBILE = "Phone number is required.";
        } else if (!/^((50|52|54|55|56|58|59|2|4|6|7)\d{7})$/.test(updatePayload.MOBILE)) {
            newErrors.MOBILE = "Please enter a valid UAE phone number (e.g., 97150XXXXXXX).";
        }
        setErrors(newErrors);
        return newErrors;
    };

    const handleUpdate = async () => {
        if (!updatePayload.CUST_CODE || !clientID) {
            setAlertStyle({ background: FAILED_ALERT_COLOR });
            setAlertMessage({
                success: false,
                message: "Missing important data for update",
                mode: "PROFILE",
            });
            setShowAlert("d-block");
            return;
        }

        setIsUpdateLoading(true);

        try {
            const payLoad = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "LoyUpdateCustomer",
                SEND_KEY: "123456",
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    TYPE_NAME: "CUSTOMER_UPDATE",
                    CUSTOMER_DETAILS: {
                        ...updatePayload,
                        MOBILE: mobilePrefix + updatePayload.MOBILE.replace(mobilePrefix, ""),
                        profile_img: getImgNameFromURL(updatePayload?.profile_img),
                    },
                    CLIENT_ID: clientID,
                },
            };

            const { data } = await axiosInstance.post(`${baseURL}/LoyUpdateCustomer`, payLoad);

            if (data.STATUS) {
                await fetchCustomerData();
            } else {
                setAlertStyle({ background: FAILED_ALERT_COLOR });
                setAlertMessage({
                    success: false,
                    message: "Failed to update",
                    mode: "PROFILE",
                });
                setShowAlert("d-block");
            }
        } catch (error) {
            console.error("Error updating customer data:", error);
            setAlertStyle({ background: FAILED_ALERT_COLOR });
            setAlertMessage({
                success: false,
                message: "An error occurred while updating the customer data.",
                mode: "PROFILE",
            });
            setShowAlert("d-block");
            await fetchCustomerData();
        } finally {
            setIsUpdateLoading(false);
            closePickers();
        }
    };

    const ProfilePhotoUpload = () => (
        <div className="w-100 mx-auto border border-1 border-top-0 border-end-0 border-start-0 p-2 mb-0 font-size-14 d-flex justify-content-between font-weight-500">
            <input type="file" id="file" className="d-none" ref={fileInput} onChange={updateFile} name="myFile" />
            <label htmlFor="file" className="col text-wafaa-black-1 w-100 d-flex">
                Change profile photo
                <span className="col text-truncate text-end">{fileName}</span>
            </label>
        </div>
    );

    const ModalTrigger = ({ modalId, label, value, border = true }) => (
        <p
            onClick={() => setPickers((prev) => ({ ...prev, [modalId]: true }))}
            className={`w-100 mx-auto border border-1 border-top-0 border-end-0 border-start-0 p-2 mb-0 font-size-14 d-flex justify-content-between font-weight-500${!border ? " border-0" : ""}`}
        >
            <span className="text-wafaa-black-1">{label}</span>
            <span className="text-blue-white">{value}</span>
        </p>
    );

    const renderProfileSection = () => {
        if (isUpdateLoading || isDataLoading) return <ProfileSkeleton />;
        return (
            <div className="position-sticky z-2">
                <div className="transition-0-5-bounce height-100">
                    <PageTitle>
                        <div className="transition-0-5-ease d-flex justify-content-center align-items-center mt-0">
                            <div className="transition-0-5-ease align-items-center text-white px-0 d-flex justify-content-between flex-column">
                                <img
                                    src={updatePayload.profile_img || defaultProfile}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultProfile;
                                    }}
                                    alt="Profile"
                                    className="height-60 width-60 rounded-circle border border-3 border-wafaa-purple object-fit-cover"
                                />
                                <p className="mb-0 font-size-22 font-weight-700">{`${updatePayload?.FIRSTNAME} ${updatePayload?.LASTNAME}`}</p>
                            </div>
                        </div>
                    </PageTitle>
                </div>
            </div>
        );
    };

    const renderPersonalDetails = () => {
        if (isUpdateLoading || isDataLoading) return <CardSkeleton items={5} />;
        return (
            <>
                <div className="w-95 mx-auto px-2">
                    <p className="mb-0 font-size-14 font-weight-500 text-wafaa-black-1">PERSONAL DETAILS</p>
                </div>
                <div className="bg-wafaa-white-2 mx-3 my-3 py-1" style={cardStyle}>
                    <ProfilePhotoUpload />
                    <ModalTrigger modalId="name" label="Full Name" value={`${updatePayload.FIRSTNAME} ${updatePayload.LASTNAME}`} />
                    <ModalTrigger modalId="gender" label="Gender" value={updatePayload.GENDER} />
                    <ModalTrigger modalId="birthDate" label="Birthday" value={moment(updatePayload?.BIRTHDATE).format("DD.MM.YYYY")} />
                    <ModalTrigger border={false} modalId="nationality" label="Nationality" value={updatePayload.NATIONALITY} />
                </div>
            </>
        );
    };

    const renderContactInfo = () => {
        if (isUpdateLoading || isDataLoading) return <CardSkeleton items={6} />;
        return (
            <>
                <div className="w-95 mx-auto px-2" style={{ marginTop: "1.5rem" }}>
                    <p className="mb-0 font-size-14 font-weight-500 text-wafaa-black-1">CONTACT AND COUNTRY INFORMATION</p>
                </div>
                <div className="bg-wafaa-white-2 mx-3 my-3 py-1" style={cardStyle}>
                    <ModalTrigger modalId="mobile" label="Mobile Number" value={mobilePrefix + updatePayload.MOBILE} />
                    <ModalTrigger modalId="email" label="Email" value={updatePayload.EMAIL} />
                    <ModalTrigger modalId="country" label="Country" value={updatePayload.COUNTRY} />
                    <ModalTrigger modalId="city" label="City" value={updatePayload.CITY} />
                    <ModalTrigger modalId="area" label="Area" value={updatePayload.AREA} />
                    <div className="w-100 mx-auto p-2 mb-0 font-size-14 d-flex justify-content-between font-weight-500">
                        <span className="text-wafaa-black-1">Currency</span>
                        <span className="text-blue-white">UAE Dirham</span>
                    </div>
                </div>
            </>
        );
    };

    const handleSelect = useCallback(
        (field) => (value) => {
            setUpdatePayload((prev) => ({ ...prev, [field]: value }));
        },
        []
    );

    const handleSelectCode = (field) => (value) => {
        if (field === "city_code" && value.length > 4) return;
        setUpdatePayload((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <AnimatedPage>
            <Alert showAlert={showAlert} alertStyle={alertStyle} alertMessage={alertMessage} hideAlert={hideAlert} />
            {renderProfileSection()}
            <div
                style={{
                    minHeight: "calc(100dvh - 148px)",
                    marginTop: "2rem",
                    position: "relative",
                }}
                className="w-100 overflow-y-scroll pb-5 transition-0-5-bounce bg-wafaa-white-3 pt-5 pb-5"
                ref={homeSection}
            >
                <div className="w-100 mx-auto px-2">
                    {pickers.name && (
                        <BottomSheet onSave={() => validateField("name", validateNameFields) && handleUpdate()} onClose={() => handleClosePickers("name")} height="auto" loading={isUpdateLoading}>
                            <CustomInputField
                                key="FIRSTNAME"
                                label="First Name"
                                name="FIRSTNAME"
                                type="text"
                                value={updatePayload.FIRSTNAME || ""}
                                onChange={handleInputChange}
                                error={!!errors.FIRSTNAME}
                                helperText={errors.FIRSTNAME}
                            />
                            <CustomInputField
                                key="LASTNAME"
                                label="Last Name"
                                name="LASTNAME"
                                type="text"
                                value={updatePayload.LASTNAME || ""}
                                onChange={handleInputChange}
                                error={!!errors.LASTNAME}
                                helperText={errors.LASTNAME}
                            />
                        </BottomSheet>
                    )}
                    {pickers.birthDate && (
                        <BottomSheet onSave={() => validateField("birthDate", validateDOB) && handleUpdate()} onClose={() => handleClosePickers("birthDate")} height="auto" loading={isUpdateLoading}>
                            <CustomInputField
                                key="BIRTHDATE"
                                label="Birth Date"
                                name="BIRTHDATE"
                                type="date"
                                value={updatePayload.BIRTHDATE?.split("T")[0] || ""}
                                onChange={handleInputChange}
                                error={!!errors.BIRTHDATE}
                                helperText={errors.BIRTHDATE}
                            />
                        </BottomSheet>
                    )}
                    {pickers.email && (
                        <BottomSheet onClose={() => handleClosePickers("email")} onSave={() => validateField("email", validateEmail) && handleUpdate()} height="auto" loading={isUpdateLoading}>
                            <CustomInputField key="EMAIL" label="E Mail" name="EMAIL" type="email" value={updatePayload.EMAIL || ""} onChange={handleInputChange} error={!!errors.EMAIL} helperText={errors.EMAIL} />
                        </BottomSheet>
                    )}
                    {pickers.gender && (
                        <IOSPicker
                            options={options.genders}
                            selectedValue={updatePayload.GENDER}
                            selectedName={updatePayload.GENDER}
                            onSelect={handleSelect("GENDER")}
                            openModal={pickers.gender}
                            title="Gender"
                            handleClose={() => handleCloseIOSPickers("gender")}
                            keyName="gender_name"
                            noResult="No genders found"
                        />
                    )}
                    {pickers.nationality && (
                        <IOSPicker
                            options={options.nationalities}
                            selectedValue={updatePayload.NATIONALITY}
                            selectedName={updatePayload.NATIONALITY}
                            onSelect={handleSelect("NATIONALITY")}
                            openModal={pickers.nationality}
                            title="Nationality"
                            handleClose={() => handleCloseIOSPickers("nationality")}
                            keyName="country_name"
                        />
                    )}
                    <IOSPicker
                        options={options.cities}
                        selectedValue={updatePayload.CITY}
                        selectedName={updatePayload.CITY}
                        onSelect={handleSelect("CITY")}
                        onSelectCode={handleSelectCode("city_code")}
                        openModal={pickers.city}
                        title="City"
                        handleClose={() => handleCloseIOSPickers("city")}
                        keyCode="city_code"
                        keyName="city_name"
                    />
                    <IOSPicker
                        options={options.areas}
                        selectedValue={updatePayload.AREA}
                        selectedName={updatePayload.AREA}
                        onSelect={handleSelect("AREA")}
                        onSelectCode={handleSelectCode("area_code")}
                        openModal={pickers.area}
                        title="Area"
                        handleClose={() => handleCloseIOSPickers("area")}
                        keyCode="area_code"
                        keyName="area_name"
                    />
                    {renderPersonalDetails()}
                    {renderContactInfo()}
                </div>
            </div>
        </AnimatedPage>
    );
}

export default MyProfile;
